









































































































import { Component, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'

import MatchMixin from '@/mixins/match'

// Match subviews
import GameClockMain from './GameClock/Main.vue'
import TeamView from './Team.vue'
import Footer from './Footer.vue'

// Dialog views
import ApiLinkDialog from './ApiLinkDialog.vue'
import EditMatchDialog from './EditDialog.vue'
import PenaltiesDialog from './PenaltiesDialog.vue'

@Component({
  components: {
    ApiLinkDialog,
    EditMatchDialog,
    MatchFooter: Footer,
    GameClock: GameClockMain,
    PenaltiesDialog,
    Team: TeamView,
  },

  computed: {
    // From root state
    ...mapState(['onLine']), // online status (connected to internet?)

    // From modules
    ...mapState('match', ['match', 'controlsLocked']), // map state-properties from 'match'-module
  },
})
export default class MatchView extends MatchMixin {
  // Penalties-dialog
  penaltiesDialog = { open: false }

  // "Edit match"-dialog
  editMatchDialog = { open: false }

  // "API link"-dialog
  apiLinkDialog = { open: false }

  // Loading state - is match loading?
  loading = true

  // Wake-lock to keep screen staying awake
  // Currently only available in Google Chrome 84+, Opera and Edge (due to Chromium)
  // https://developer.mozilla.org/en-US/docs/Web/API/Screen_Wake_Lock_API
  wakeLock = null

  async created(): Promise<void> {
    // Unbind match?
    if (!this.$route.params.matchId) {
      this.$store.dispatch('match/bindMatch', this.$route.params.matchId)
    }

    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.wakeLock = await navigator.wakeLock.request('screen')
    } catch (err) {
      // The Wake Lock request has failed - usually system related, such as battery.
      // console.error(err.name, err.message)
    }
  }

  beforeDestroy(): void {
    this.$store.dispatch('match/unbindMatch')

    // Release wake lock
    if (this.wakeLock) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.wakeLock.release().then(() => {
        this.wakeLock = null
      })
    }
  }

  @Watch('$route.params.matchId', { immediate: true })
  onMatchIdParamChanged(val: string): void {
    // Guard matchId param
    if (val && val.length > 2) {
      this.$store.dispatch('match/bindMatch', val).then(() => {
        this.loading = false
      })
      return
    }

    // No match ID value
    // Unbind
    this.$store.dispatch('match/unbindMatch').then(() => {
      this.loading = false
    })
  }

  confirmGotoNextPeriod(): void {
    if (this.$store.getters['match/isAtEndOfCurrentPeriod']) {
      this.$store.dispatch('match/gotoNextPeriod')
      return
    }

    if (confirm('Are you sure you want to go to next period?')) {
      this.$store.dispatch('match/forceGotoNextPeriod')
    }
  }
}
